export const partitionArray = (a, filterFunction) => a.reduce(([pass, fail], element) => (filterFunction(element) ? [[...pass, element], fail] : [pass, [...fail, element]]), [[], []]);
